<script>
    export default {
        props: {
            color: String,
        },
    }
</script>


<template>
    <div 
        class="mr_10"
        :style="{backgroundColor: color}" 
    ></div>
</template>


<style scoped>
    div {
        flex: 0 0 75px;
        border-radius: 20px;
        height: 100%;
    }
</style>